var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noIntroduction"},[_c('img',{attrs:{"src":require('../assets/image/images/website_absent_280.png')}}),_vm._v(" "),_c('span',[_vm._v("网站不存在...")]),_vm._v(" "),_c('span',{staticClass:"interval"},[_vm._v(_vm._s(_vm.distance)+"秒后自动跳转")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-468459f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invalidPage.vue
// module id = null
// module chunks = 